export default {
	attributes: {
		design: 'basic',
		color: '#6d6d6d',
		height: 3,
		width: 50,
		alignment: 'center',
		uniqueClass: 'ugb-dd90352',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
	},
}
